import { useState, useEffect } from 'react';


export default function useIsDemo() {
    const isDemo = new URLSearchParams(window.location.search).has("isDemo");
    return isDemo;
}
